var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80589 5.22461L8.6453 6.93165L9.48472 5.22461H10.8955L9.46355 7.77107L10.9343 10.3598H9.5094L8.6453 8.62106L7.7812 10.3598H6.35278L7.82705 7.77107L6.39158 5.22461H7.80589Z",
    fill: "#093C5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61734 1.60251H14.7381L14.7381 13.0547H14.7449V16.0072C15.7426 16.004 16.5503 15.2895 16.5503 14.4086V1.60251C16.5503 0.719624 15.7389 0.00390625 14.7381 0.00390625H2.61734C1.61651 0.00390625 0.805176 0.719626 0.805176 1.60251V14.4087C0.805176 15.2915 1.61651 16.0073 2.61734 16.0073H9.5813V14.4087L2.61734 14.4087V1.60251Z",
    fill: "#093C5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.701 16.4896H13.8541V13.8266C13.8541 13.5336 13.6145 13.2939 13.3215 13.2939H11.1911C10.8981 13.2939 10.6585 13.5336 10.6585 13.8266V16.4896H9.8116C9.33758 16.4896 9.0979 17.0648 9.43345 17.4004L11.8781 19.8451C12.0859 20.0528 12.4214 20.0528 12.6291 19.8451L15.0738 17.4004C15.4094 17.0648 15.175 16.4896 14.701 16.4896Z",
    fill: "#093C5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownExcel);
export default __webpack_public_path__ + "static/media/downExcel.d2a01413f843dd7e482137ba7bc24081.svg";
export { ForwardRef as ReactComponent };